import { cn } from '@/shared/lib/cn';

export interface LoaderProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  label?: string;
}

const sizeStyles = {
  sm: 'h-4 w-4',
  md: 'h-8 w-8',
  lg: 'h-12 w-12',
} as const;

/** Intrinsic px sizes so the SVG never expands before Tailwind CSS applies. */
const sizePx = {
  sm: 16,
  md: 32,
  lg: 48,
} as const;

export function Loader({
  size = 'md',
  className,
  label = 'Loading',
}: LoaderProps) {
  const px = sizePx[size];

  return (
    <div
      role="status"
      aria-label={label}
      className={cn('flex items-center justify-center', className)}
    >
      <svg
        width={px}
        height={px}
        className={cn('animate-spin text-primary', sizeStyles[size])}
        style={{ width: px, height: px }}
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        aria-hidden="true"
      >
        <circle
          className="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="4"
        />
        <path
          className="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
        />
      </svg>
      <span className="sr-only">{label}</span>
    </div>
  );
}
